import "./TechnicalSeo.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Technicalfoundation from "./sections/Technicalfoundation";
import TechnicalSeoBenefits from "./sections/TechnicalSeoBenefits";
import Auditprocess from "./sections/Auditprocess";
import Technicalfaq from "./sections/Technicalfaq";
import TechnicalAuditCTA from "./sections/TechnicalAuditCTA";
import Footer from "@/reusable_sections/Footer";
export default function TechnicalSeoPage() {
  return <div>
      <Header />
      <Services />
      <Technicalfoundation />
      <TechnicalSeoBenefits />
      <Auditprocess />
      <Technicalfaq />
      <TechnicalAuditCTA />
      <Footer />
    </div>;
}